import { WarningTriangle } from '@/assets/icons'

type WarningBannerProps = {
  message: string
  action?: {
    label: string
    onClick: () => void
  }
}

export default function WarningBanner(props: WarningBannerProps) {
  const { message, action } = props

  return (
    <div className="bg-yellow-50 w-full md:rounded-md flex items-center gap-2 justify-start p-2 md:border-t-0 border-t border-brand-neutral-200">
      <WarningTriangle className={`text-yellow-800 size-3 md:size-4 flex-shrink-0`} />
      <p className={`text-yellow-800 text-xs font-normal md:leading-6 leading-4`}>{message}</p>
      {action && (
        <button className={`text-yellow-800 text-xs font-normal`} onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  )
}
